<template>
  <section class="section height-100">
    <div class="tile is-ancestor full-width is-vertical height-100">
        <div class="tile is-parent is-horizontal">
          <dashboard-banner-tile
            :title="$t('Solicitudes')"
            :subtitle="
              $t('Aprovecha al maximo la tecnologia que te permite Myneo 40')
            "
            :ctaText="$t('Acceder')"
            ctaTarget="admin.onBoard.list"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-solicitudes.jpg"
          ></dashboard-banner-tile>

          <dashboard-banner-tile
            :title="$t('Reunion')"
            :subtitle="
              $t(
                'Solicita una reunion con la app que mas se adapte a tu dispositivo'
              )
            "
            :ctaText="$t('Acceder')"
            ctaTarget="https://ecobanka.com/formulario-de-contacto-ecobanka"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-reunion.jpg"
          >
            <div class="level" style="background: var(--rosa-eco);padding: 15px; border-radius: 10px; margin-top: 10px;" >
              <div class="level-item">
                <img src="~@/assets/icons/telegram_logo_36.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Telegram</h4>
              </div>
              <div class="level-item">
                <img src="~@/assets/icons/whatsapp_logo_36.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Whatsapp</h4>
              </div>
              <div class="level-item">
                <img src="~@/assets/icons/google_meet_48.png" alt="" height="20" width="36" />
                <h4 class="title is-5 has-text-white">Meet</h4>
              </div>
            </div>
          </dashboard-banner-tile>
        </div>

        <div class="tile is-parent">
            <iframe
              width="100%"
              style="height: 360px;"
              src="https://www.youtube.com/embed/videoseries?list=PL3DOb74zZ2pOS2wc4GdEkL1c7fW3E0KTz"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="tile is-child"
            ></iframe>
          <dashboard-banner-tile
            :title="$t('Red de ejecutivos internacionales')"
            :ctaText="$t('Acceder')"
            ctaTarget="admin.users.list"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-red.jpg"
          ></dashboard-banner-tile>
        </div>

        <div class="tile is-parent">
          <div class="tile is-parent">
            <dashboard-banner-tile
              :title="$t('Compartimos experiencias')"
              :ctaText="$t('Acceder')"
              backgroundImage="https://ecobanka.com/wp-content/uploads/2018/05/Trama_tv.jpg"
              ctaTarget="https://ecobanka.com"
            ></dashboard-banner-tile>
            <dashboard-banner-tile
              :title="$t('MyChat')"
              :ctaText="$t('Acceder')"
              ctaTarget="admin.my_chat"
              backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-mychat.jpg"
            ></dashboard-banner-tile>
          </div>
          <dashboard-banner-tile
            :title="$t('Red de contactos Corporativos Directos')"
            :subtitle="$t('Emprendedores Pymes y Compañías')"
            :ctaText="$t('Acceder')"
            ctaTarget="admin.onBoard.list"
            backgroundImage="https://elitek-s3.s3.amazonaws.com/2020-10-12-contactos.jpg"
          ></dashboard-banner-tile>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import DashboardBannerTile from '@/components/admin/dasboard/DashboardBannerTile.vue'
export default {
  name: 'Dashboard',
  components: { DashboardBannerTile },
  computed: {},
  data() {
    return {}
  },
  mounted() {
    this.$store.commit('layout/SUB_PAGE', {
      stack: ['Admin', 'Dashboard'],
      title: 'Dashboard'
    })
  }
}
</script>

<style scoped>
.bg-blur {
  background: #ffffff99;
  border-radius: 10px;
  backdrop-filter: blur(5px) brightness(1.2);
}
.tile.is-child {
  background-size: cover !important;
}
.height-100 {
  height: 100%;
}
</style>
